// extracted by mini-css-extract-plugin
export var title = "card-module--title--DPTd7";
export var price = "card-module--price--Bk6lN";